"use client";

import { MouseEvent } from "react";
export default function HeroLocations() {
  const handleScrollToLocations = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById("main-center");
    target?.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };
  return <section id="hero" className="relative overflow-hidden bg-[#0f172a] px-6 py-24 text-white md:px-12 md:py-32">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.06),transparent_34%)]" />
        <div className="absolute left-0 top-0 h-80 w-80 rounded-full bg-white/[0.03] blur-3xl" />
        <div className="absolute bottom-0 right-0 h-80 w-80 rounded-full bg-[#166534]/[0.08] blur-3xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="max-w-4xl">
            <div className="mb-5 inline-flex items-center rounded-full border border-white/10 bg-white/[0.06] px-4 py-2 text-[11px] font-medium uppercase tracking-[0.22em] text-white/72 backdrop-blur-md sm:text-xs">
              Две локации MONA
            </div>

            <h1 className="mb-6 font-default text-4xl font-bold tracking-[-0.04em] text-white sm:text-5xl md:text-6xl lg:text-7xl">
              Две локации —
              <br />
              <span className="text-[#166534]">одна система развития</span>
            </h1>

            <div className="mb-8 max-w-3xl space-y-4 font-default text-lg leading-relaxed text-white/78 md:text-xl">
              <p>
                У MONA две локации, и каждая из них выполняет свою задачу в
                развитии ребёнка.
              </p>
              <p>
                Основной центр даёт структуру, ежедневную практику и системные
                занятия. Ферма добавляет сенсорный опыт, природу, взаимодействие
                с животными и эмоциональную устойчивость.
              </p>
              <p>
                Вместе они формируют единую среду, в которой ребёнок развивается
                увереннее, спокойнее и естественнее.
              </p>
            </div>

            <a href="#main-center" onClick={handleScrollToLocations} className="group relative inline-flex h-14 items-center justify-center overflow-hidden rounded-full border border-white/10 bg-white px-10 text-base font-semibold text-slate-900 shadow-[0_12px_32px_rgba(15,23,42,0.22)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_18px_42px_rgba(15,23,42,0.28)]">
              <span className="relative z-10">Смотреть локации</span>
            </a>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-1">
            <div className="rounded-[32px] border border-white/12 bg-white/[0.08] p-8 shadow-[0_16px_46px_rgba(0,0,0,0.18)] backdrop-blur-xl">
              <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/[0.08]">
                <span className="text-xl text-[#d8c27a]">01</span>
              </div>

              <h3 className="mb-3 font-default text-2xl font-semibold tracking-[-0.03em] text-white">
                Основной центр
              </h3>

              <p className="font-default text-base leading-7 text-white/78">
                Ежедневные занятия, структурная среда, оборудованные пространства
                и системная работа над навыками.
              </p>
            </div>

            <div className="rounded-[32px] border border-white/12 bg-white/[0.08] p-8 shadow-[0_16px_46px_rgba(0,0,0,0.18)] backdrop-blur-xl">
              <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/[0.08]">
                <span className="text-xl text-[#d8c27a]">02</span>
              </div>

              <h3 className="mb-3 font-default text-2xl font-semibold tracking-[-0.03em] text-white">
                Ферма
              </h3>

              <p className="font-default text-base leading-7 text-white/78">
                Природная среда, иппотерапия, животные, прогулки и сенсорный опыт,
                который делает развитие глубже и живее.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}